export type responsiveAliases =
  | 'xs'
  | 'gtXs'
  | 'ltSm'
  | 'sm'
  | 'gtSm'
  | 'ltMd'
  | 'md'
  | 'gtMd'
  | 'ltLg'
  | 'lg'
  | 'gtLg'
  | 'ltXl'
  | 'xl'
  | 'handsetP'
  | 'handsetL'
  | 'tabletP'
  | 'tabletL';

export interface Breakpoint {
  alias: responsiveAliases;
  mediaQuery: string;
}

export const DEFAULT_BREAKPOINTS: Breakpoint[] = [
  {
    alias: 'xs',
    mediaQuery: '(min-width: 0px) and (max-width: 599px)',
  },
  {
    alias: 'gtXs',
    mediaQuery: '(min-width: 600px)',
  },
  {
    alias: 'ltSm',
    mediaQuery: '(max-width: 599px)',
  },
  {
    alias: 'sm',
    mediaQuery: '(min-width: 600px) and (max-width: 959px)',
  },
  {
    alias: 'gtSm',
    mediaQuery: '(min-width: 960px)',
  },
  {
    alias: 'ltMd',
    mediaQuery: '(max-width: 959px)',
  },
  {
    alias: 'md',
    mediaQuery: '(min-width: 960px) and (max-width: 1399px)',
  },
  {
    alias: 'gtMd',
    mediaQuery: '(min-width: 1400px)',
  },
  {
    alias: 'ltLg',
    mediaQuery: '(max-width: 1399px)',
  },
  {
    alias: 'lg',
    mediaQuery: '(min-width: 1400px) and (max-width: 1919px)',
  },
  {
    alias: 'gtLg',
    mediaQuery: '(min-width: 1920px)',
  },
  {
    alias: 'ltXl',
    mediaQuery: '(max-width: 1919px)',
  },
  {
    alias: 'xl',
    mediaQuery: '(min-width: 1920px) and (max-width: 5000px)',
  },
  {
    alias: 'handsetP',
    mediaQuery: '(orientation: portrait) and (max-width: 599px)',
  },
  {
    alias: 'handsetL',
    mediaQuery: '(orientation: landscape) and (max-width: 959px)',
  },
  {
    alias: 'tabletL',
    mediaQuery:
      '(orientation: landscape) and (min-width: 960px) and (max-width: 1279px)',
  },
  {
    alias: 'tabletP',
    mediaQuery:
      '(orientation: portrait) and (min-width: 600px) and (max-width: 839px)',
  },
];
